import { render, staticRenderFns } from "./shared_with_me.table.vue?vue&type=template&id=e109264c&"
import script from "./shared_with_me.table.vue?vue&type=script&lang=js&"
export * from "./shared_with_me.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports